/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  McpServerActivity,
  McpServerActivity$inboundSchema,
} from "./mcpserveractivity.js";

/**
 * Per-MCP-server tool-call activity. Only servers with at least one tool call inside the lookback window are returned; a server absent from the list has never received a tool call (within the telemetry retention window).
 */
export type GetMcpServerActivityResult = {
  /**
   * One entry per MCP server (hosted, tunneled, or gateway) that has received at least one tool call within the lookback window
   */
  activity: Array<McpServerActivity>;
  /**
   * The overall lookback window size in days (bounded by telemetry retention)
   */
  lookbackDays: number;
  /**
   * The recent-activity window size in days that was applied
   */
  recentWindowDays: number;
};

/** @internal */
export const GetMcpServerActivityResult$inboundSchema: z.ZodMiniType<
  GetMcpServerActivityResult,
  unknown
> = z.pipe(
  z.object({
    activity: z.array(McpServerActivity$inboundSchema),
    lookback_days: z.int(),
    recent_window_days: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "lookback_days": "lookbackDays",
      "recent_window_days": "recentWindowDays",
    });
  }),
);

export function getMcpServerActivityResultFromJSON(
  jsonString: string,
): SafeParseResult<GetMcpServerActivityResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMcpServerActivityResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMcpServerActivityResult' from JSON`,
  );
}
